module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7S8be"))).then(() => parcelRequire('2KbAe'));